import Lottie from "lottie-react";
import SuccessAnimation from "../../../../shared/lottie/success.json";

const VendorEmailPlaceHolder = () => {

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full h-full bg-white flex items-center px-24 gap-32 rounded-lg">
        <div className="grow w-full flex flex-col items-start justify-center gap-4">
          <h4 className="text-4xl font-semibold leading-[60px]">
            <div>Evaluation Form</div>
            {/* TODO make placeholder dynamic */}
            <div>Submitted to {`Google`}!</div>
          </h4>
          <h6 className="text-md text-[#71717A]">
            Your responses are under review. Our team will contact you if any additional details are needed.
          </h6>
        </div>
        <div className="grow w-full flex flex-col items-start justify-center gap-4">
          <Lottie animationData={SuccessAnimation} loop={false} />
        </div>
      </div>
    </div>
  );
};

export default VendorEmailPlaceHolder;
